export const getProductSalePercentage = {
  computed: {
    getSalePercentage() {
      return (
        ~~(
          ((this.product.priceOriginal - this.product.priceSale) /
            this.product.priceOriginal) *
          100
        ).toString() + "%"
      );
    }
  }
};
